import React from 'react';
import ContactForm from './ContactForm';

function ContactSection() {
  return (
    <section className="section contact-section" id="kontak" aria-labelledby="contact-title">
      <div className="container contact-layout">
        <div className="contact-intro">
          <p className="eyebrow eyebrow-dark">Mari terhubung</p>
          <h2 id="contact-title">Punya ide untuk <span>dibicarakan?</span></h2>
          <p>Kirim pesan kepada kami atau hubungi langsung melalui WhatsApp.</p>
          <a className="contact-direct" href="https://bit.ly/WACoachYuan" target="_blank" rel="noopener noreferrer">
            <span className="direct-icon" aria-hidden="true">↗</span>
            <span><b>Chat WhatsApp</b><small>Konsultasi dan pertanyaan</small></span>
          </a>
          <a className="phone-link" href="tel:+6281264656688">0812-6465-6688</a>
        </div>
        <div className="form-panel">
          <h3>Kirim pesan</h3>
          <p className="form-lead">Ceritakan apa yang sedang Anda cari.</p>
          <ContactForm />
          <div data-greta-form-placeholder="Kontak">This form is not collecting yet.</div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;